"use client"

/**
 * Client island wrapper for the city provider map. Keeps the leaflet import out
 * of the server bundle; every crawlable block on the city page is rendered by
 * the server component around it.
 */

import dynamic from 'next/dynamic'
import type { ProviderMapPoint } from './provider-map'

const ProviderMap = dynamic(
  () => import('./provider-map').then((m) => ({ default: m.ProviderMap })),
  {
    ssr: false,
    loading: () => (
      <div className="h-[380px] w-full animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-gray-100" />
    ),
  },
)

export function ProviderMapIsland({
  points,
  center,
  cityName,
}: {
  points: ProviderMapPoint[]
  center: [number, number]
  cityName: string
}) {
  if (points.length === 0) return null
  return <ProviderMap points={points} center={center} cityName={cityName} />
}

export type { ProviderMapPoint }
